export const bookingsStatusColorCode = [
    {
        label: "open",
        colorBg: "bg-[#F3CBA9]",
        colorText: "text-[#DE6F0D]"
    },
    {
        label: "rental",
        colorBg: "bg-[#D9F4D4]",
        colorText: "text-[#039855]"
    },
    {
        label: "completed",
        colorBg: "bg-[#CCE4F7]",
        colorText: "text-[#1B2AFE]"
    },
    {
        label: "cancelled",
        colorBg: "bg-[#FEDFDD]",
        colorText: "text-[#D92D20]"
    },
    {
        label: "cancelled paid",
        colorBg: "bg-[#FEDFDD]",
        colorText: "text-[#D92D20]"
    },
    {
        label: "quotes",
        colorBg: "bg-[#9ACBD0]",
        colorText: "text-[#006A71]"
    },
    {
        label: "pending",
        colorBg: "bg-[#E27861]",
        colorText: "text-[#673128]"
    },
    {
        label: "no show",
        colorBg: "bg-[#D256B0]",
        colorText: "text-[#7D1C4A]"
    },
    {
        label: "reopen",
        colorBg: "bg-[#F3CBA9]",
        colorText: "text-[#DE6F0D]"
    },
    {
        label: "overdue",
        colorBg: "bg-[#F3CBA9]",
        colorText: "text-[#DE6F0D]"
    },
]